import * as yup from 'yup';
import { PermissionCreateModel, PermissionUpdateModel } from './permission.model';

const codeRule = yup
  .string()
  .required('ກະລຸນາປ້ອນລະຫັດສິດທິ')
  .matches(/^[a-z0-9-]+(:[a-z0-9-]+)+$/, 'ຮູບແບບຕ້ອງເປັນ module:resource:action (ຕ.ຢ. mseg:role:create)');

export const permissionCreateSchema: yup.ObjectSchema<PermissionCreateModel> = yup.object({
  code: codeRule,
  name: yup.string().required('ກະລຸນາປ້ອນຊື່ສິດທິ'),
  module: yup.string().required('ກະລຸນາປ້ອນ module'),
  description: yup.string().optional(),
});

export const permissionUpdateSchema: yup.ObjectSchema<PermissionUpdateModel> = yup.object({
  uuid: yup.string().optional(),
  code: codeRule,
  name: yup.string().required('ກະລຸນາປ້ອນຊື່ສິດທິ'),
  module: yup.string().required('ກະລຸນາປ້ອນ module'),
  description: yup.string().optional(),
  is_active: yup.boolean().optional(),
});
